import React, { forwardRef } from 'react';
import styled from 'styled-components';
import { variant } from 'styled-system';
import { tabNavigationStyle } from '../../helpers/tabNavigationStyle';
const Component = styled.a `
  color: ${({ isSecondary, theme, color }) => isSecondary ? theme.colors.black : theme.colors[color]};
  cursor: pointer;
  text-decoration: ${({ isUnderlined }) => isUnderlined ? 'underline' : 'none'};
  background-color: ${({ theme }) => theme.colors.transparent};
  border: none;
  transition: color 300ms cubic-bezier(0.22, 1, 0.36, 1);

  &:hover {
    color: ${({ theme, color }) => theme.colorShade({ type: 'hover', color: color })};
    text-decoration: underline;
    transition: color 300ms cubic-bezier(0.22, 1, 0.36, 1);
  }

  &:active {
    color: ${({ theme, color }) => theme.colorShade({
    type: 'pressed',
    color: color,
})};
  }

  ${variant({
    prop: 'textSize',
    scale: 'textSizes',
})};

  ${({ isBold, theme }) => isBold ? `font-weight: ${theme.fontWeights.bold}` : ''};

  ${({ isUppercased }) => (isUppercased ? 'text-transform: uppercase' : '')};

  ${({ hasAccessibilitySize, isBlock }) => isBlock || hasAccessibilitySize
    ? `
        display: flex;
        align-items: center;
      `
    : ''}

  ${({ isBlock, theme }) => isBlock
    ? `
        width: 100%;
        min-height: ${theme.space.x32};
      `
    : ''}

  ${({ hasAccessibilitySize, theme }) => hasAccessibilitySize
    ? `
        min-height: ${theme.space.x48};
        min-width: ${theme.space.x48};
      `
    : ''}

  ${tabNavigationStyle};
`;
export const Anchor = forwardRef(({ htmlAttrs = {}, isExternal, children, ...rest }, ref) => (React.createElement(Component, { ...htmlAttrs, ...rest, ref: ref, ...(isExternal && {
        rel: 'noopener noreferrer',
        target: '_blank',
    }) }, children)));
Anchor.displayName = 'Anchor';
Anchor.defaultProps = {
    color: 'primary',
    isExternal: false,
    isSecondary: false,
    isUppercased: false,
    hasAccessibilitySize: false,
};
//# sourceMappingURL=index.js.map